import React from "react";
import { createRoot } from "react-dom/client";

import App from "./Root";

class AfricaRegionPageMapApp {
  constructor(htmlNode, initialState) {
    createRoot(htmlNode).render(<App {...initialState} />);
  }
}

export default AfricaRegionPageMapApp;
